import React from 'react'
import styled from 'styled-components'

const LiquidLoader = ({ size = 120, className }) => {
  return (
    <Container size={size} className={className}>
      <StyledSVG viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Gooey filter */}
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="goo"
            />
          </filter>

          {/* Gradient for color animation */}
          <linearGradient id="liquidGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <GradientStop offset="0%" className="stop1" />
            <GradientStop offset="100%" className="stop2" />
          </linearGradient>
        </defs>

        <BlobGroup filter="url(#goo)">
          <Circle1 cx="60" cy="60" r="15" />
          <Circle2 cx="60" cy="60" r="12" />
          <Circle3 cx="60" cy="60" r="10" />
          <Circle4 cx="60" cy="60" r="9" />
        </BlobGroup>
      </StyledSVG>
    </Container>
  )
}

const Container = styled.div.attrs({
  role: 'status',
  'aria-label': 'Caricamento in corso',
  'aria-live': 'polite'
})`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: inline-block;
`

const StyledSVG = styled.svg`
  width: 100%;
  height: 100%;
`

const BlobGroup = styled.g`
  /* Group for gooey filter */
`

const GradientStop = styled.stop`
  stop-color: ${props => props.theme.colors?.text?.primary || '#000000'};
  animation: gradientShift 6s ease-in-out infinite;

  &:nth-child(2) {
    animation-delay: -3s;
  }

  @keyframes gradientShift {
    0%, 100% {
      stop-color: ${props => props.theme.colors?.text?.primary || '#000000'};
    }
    50% {
      stop-color: ${props => props.theme.colors?.success?.main || '#22c55e'};
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

const Circle1 = styled.circle`
  fill: url(#liquidGradient);
  animation: orbit1 3s cubic-bezier(0.45, 0, 0.55, 1) infinite;
  will-change: transform;

  @keyframes orbit1 {
    0%, 100% {
      transform: translate(0px, 0px);
    }
    25% {
      transform: translate(15px, 0px);
    }
    50% {
      transform: translate(0px, 15px);
    }
    75% {
      transform: translate(-15px, 0px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`

const Circle2 = styled.circle`
  fill: url(#liquidGradient);
  animation: orbit2 4s cubic-bezier(0.45, 0, 0.55, 1) infinite;
  will-change: transform;

  @keyframes orbit2 {
    0%, 100% {
      transform: translate(0px, 0px);
    }
    25% {
      transform: translate(-20px, 10px);
    }
    50% {
      transform: translate(-10px, -20px);
    }
    75% {
      transform: translate(15px, -10px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`

const Circle3 = styled.circle`
  fill: url(#liquidGradient);
  animation: orbit3 3.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;
  will-change: transform;

  @keyframes orbit3 {
    0%, 100% {
      transform: translate(0px, 0px);
    }
    33% {
      transform: translate(10px, 20px);
    }
    66% {
      transform: translate(-15px, 15px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`

const Circle4 = styled.circle`
  fill: url(#liquidGradient);
  animation: orbit4 2.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;
  will-change: transform;

  @keyframes orbit4 {
    0%, 100% {
      transform: translate(0px, 0px);
    }
    20% {
      transform: translate(18px, -12px);
    }
    40% {
      transform: translate(8px, 18px);
    }
    60% {
      transform: translate(-18px, 8px);
    }
    80% {
      transform: translate(-8px, -18px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.6;
  }
`

export default LiquidLoader
